import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import { useLocation } from "react-router-dom";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import LoginForm from "../components/login/LoginForm";
import Background from "../images/food_background.jpg";

const useStyles = makeStyles((theme) => ({
	loginView: {
		backgroundImage: `url(${Background})`,
		backgroundPosition: "center",
		backgroundRepeat: "no-repeat",
		backgroundSize: "cover",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		width: "100%",
		height: "100%",
	},
}));

export default function LoginView() {
	let bottomNavBar = false;
	const location = useLocation();
	if (location.state) {
		const { bottomnav } = location.state;
		bottomNavBar = bottomnav;
	}
	const classes = useStyles();
	return (
		<div className={("pageWrapper", classes.loginView)}>
			<LoginForm />
			{bottomNavBar ? <BottomNavBar /> : null}
		</div>
	);
}
